import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationBG from './locales/bg/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
  bg: { translation: translationBG },
  en: { translation: translationEN },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'bg',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['cookie', 'localStorage'],
      caches: ['cookie', 'localStorage'],
      cookieMinutes: 525600,
    },
  });

export default i18n;
